import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import FromCodeToConcrete from "./sections/FromCodeToConcrete";
import OurCoreDivisions from "./sections/OurCoreDivisions";
import TheNylaAdvantage from "./sections/TheNylaAdvantage";
import FeaturedProjects from "./sections/FeaturedProjects";
import RequestAConsultation from "./sections/RequestAConsultation";
import ConnectWithUs from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <FromCodeToConcrete />
      <OurCoreDivisions />
      <TheNylaAdvantage />
      <FeaturedProjects />
      <RequestAConsultation />
      <ConnectWithUs />
    </div>;
}